export const environment = {
  firebase: {
    projectId: 'virtual-exercise-6fd0a',
    appId: '1:816914350105:web:36c40f13c6a4e3fb74ea88',
    databaseURL: 'https://virtual-exercise-6fd0a-default-rtdb.firebaseio.com',
    storageBucket: 'virtual-exercise-6fd0a.appspot.com',
    apiKey: 'AIzaSyCmUcpcxUFgP5M4_7Zqv3g5OeOmegy-4dM',
    authDomain: 'virtual-exercise-6fd0a.firebaseapp.com',
    messagingSenderId: '816914350105',
    measurementId: 'G-8MGCP175LY',
  },
  production: true,
  file: "evironment.prod.ts",
  googlemapapikey: "AIzaSyDzHxwPuZH0wzIPHHvjTrz-pO_GlLMlT14",
  backendapi: "https://sensorsim-api.cellpodium.com/api/",
  scenariodid: 43,
  virtexAssets: { // These credentials are scoped to the virtex assets bucket and only allow read access
    access: "AKIAYLJXQHRYIBW55DE2",
    secret: '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',
    region: 'us-east-1',
    bucket: 'virtexassets',
    downloadUrl: 'https://virtexassets.s3.amazonaws.com',
    bucketUrl: 'https://us-east-1.console.aws.amazon.com/s3/object'
  } 
};
